import styled from "styled-components";

import Text from "@/components/Text";

const Container = styled.div`
  max-width: 942px;
  margin: 0 auto;
  padding: 96px 20px 96px;
`;

const Heading = styled(Text)`
  margin-bottom: 24px;
`;

const Content = styled(Text)`
  a {
    color: ${({ theme }) => theme.colors.purpleLighter};
    transition: opacity ease-out 0.2s;
    &:hover {
      opacity: 0.5;
    }
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Relative = styled.div`
  position: relative;
`;

const Circle = styled.div`
  width: 174px;
  height: 174px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.purple}; ;
`;

const Circle1 = styled(Circle)`
  opacity: 0.2;
  position: absolute;
  top: 0;
  left: 16px;
`;

const Circle2 = styled(Circle)`
  opacity: 0.1;
  position: absolute;
  top: 0;
  left: 32px;
`;

const Left = styled.div``;

const Right = styled.div``;

const HomeContact = () => {
  return (
    <Container>
      <Row>
        <Left>
          <Heading as="h2" $type="heading1">
            How to contact us?
          </Heading>
          <Content>
            Backbone is in a closed beta at the moment and does not accept new
            <br />
            applications. For any questions, contact{" "}
            <a href="mailto:analytics@boredpanda.com">
              analytics@boredpanda.com
            </a>
          </Content>
        </Left>
        <Right>
          <Relative>
            <Circle />
            <Circle1 />
            <Circle2 />
          </Relative>
        </Right>
      </Row>
    </Container>
  );
};

export default HomeContact;
